import { useLanguage } from '@/hooks/useLanguage';
import { interpolate } from '@/portal/format';
import { portalText, type PortalTextKey } from '@/portal/i18n/portalText';

export const usePortalText = () => {
  const { language } = useLanguage();
  const dictionary = portalText[language];

  const t = (key: PortalTextKey, vars?: Record<string, string | number>): string =>
    interpolate(dictionary[key], vars);

  const testsCount = (count: number): string =>
    count === 1 ? dictionary.testsCountOne : interpolate(dictionary.testsCount, { count });

  return { t, testsCount, language, isRTL: language === 'ar' };
};
